import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { Form } from 'react-bootstrap';
import { SERVER_URL } from './ServerConfig';
import queryString from 'query-string';
import { BeatLoader } from 'react-spinners' 

export default class ResetPassword extends Component {
    constructor(props) {
        super(props);
        const parsed = queryString.parse(this.props.location.search);
        this.state = {
            redirectToDashoard: false,
            password: '',
            confirmPassword: '',
            validated: false,
            message: '',
            isPasswordReset: false,
            isSendingResetPassword: false,
            isVerifyingLink: true,
            isLinkValid: true,
            parsed : parsed
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        fetch(SERVER_URL + '/v1/users/verifyResetPassword/' + this.state.parsed.resetPasswordId, {
            method: 'post'
        }).then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.success) {
                    this.setState({ isVerifyingLink : false })
                } else {
                    this.setState({ isVerifyingLink : false, isLinkValid : false, message: data.message });
                }
            }).catch(err => {
                this.setState({ message: "Server is in maintenance" });
            });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handleConfirmPasswordChange(event) {
        this.setState({ confirmPassword: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.password || this.state.password.length < 8 || this.state.password.length > 100) {
            this.setState({ message: 'Password must be between 8 and 100 characters long' });
            return;
        }
        if (this.state.confirmPassword !==  this.state.password) {
            this.setState({ message:  'Password and Confirm password must be the same'});
            return;
        }
        this.setState({ isSendingResetPassword: true })
        fetch(SERVER_URL + '/v1/users/updateResetPassword/' + this.state.parsed.resetPasswordId, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                newPassword: this.state.password
            })
        }).then(response => response.json())
            .then(data => {
                if (data.success === true) {
                    this.setState({ isSendingResetPassword: false, message: 'You password has been updated successfully.' , isPasswordReset: true })
                } else {
                    this.setState({ isSendingResetPassword: false, message: data.message });
                }
            }).catch(err => {
                this.setState({ message: "Server is in maintenance" });
            });
    }

    renderSubmitButton() {
        if (this.state.isSendingResetPassword) {
            return (<button type="submit" className="btn btn-primary btn-block" disabled>
                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Reset password...
            </button>);
        } else {
            return (<button type="submit" className="btn btn-primary btn-block">Reset password</button>);
        }
    }

    renderMessage() {
        if (this.state.isVerifyingLink) {
            return (
                <div className="d-flex justify-content-center mt-2">
                    <BeatLoader size={30} color="#4A90E2"/>
                </div>
            );
        }
        if (!this.state.isLinkValid) {
            return (
                <div className="col-12">
                    <div className="alert alert-warning alert-dismissible fade show">
                        <i className="icon fas fa-exclamation-triangle"></i>{this.state.message}
                    </div>
                    <p className="mt-2 mb-1">
                        Back to
                        <a href="/login"> Login </a>page
                    </p>
                </div>
            )
        }
        if (this.state.isPasswordReset) {
            return (
                <div className="col-12">
                    <div className="alert alert-success alert-dismissible fade show">
                        <i className="icon fas fa-check"></i>{this.state.message}
                    </div>
                    <p className="mt-2 mb-1">
                        Back to
                        <a href="/login"> Login </a>page
                    </p>
                </div>
            )
        }
        return (
            <div className="col-12">
                <p className="login-box-msg mt-2">You are only one step a way from your new password, recover your password now.</p>
                <div className="text-center">
                    <p className="text-danger">{this.state.message}</p>
                </div>
                <Form onSubmit={this.handleSubmit} validated={this.state.validated}>
                    <Form.Row>
                        <Form.Group controlId="validationCustom02" className="input-group mb-3">
                            <Form.Control
                                required
                                type="password"
                                placeholder="Password"
                                value={this.state.password}
                                onChange={this.handlePasswordChange}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                </div>
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group controlId="validationCustom03" className="input-group mb-3">
                            <Form.Control
                                required
                                type="password"
                                placeholder="Confirm Password"
                                value={this.state.confirmPassword}
                                onChange={this.handleConfirmPasswordChange}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                </div>
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <div className="row">
                        {this.renderSubmitButton()}
                    </div>
                </Form>
                <p className="mt-2 mb-1">
                    <a href="/login">Login</a>
                </p>
            </div>
        )
    }

    render() {
        if (this.state.redirectToDashoard) {
            return <Redirect to={{
                pathname: "/dashboard"
            }} />
        }
        return (
            <div className="hold-transition login-page">
                <div className="bg-image" />
                <div className="reset-box">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-center">
                                <h2><b>Solar </b>Monitoring</h2>
                            </div>
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}